module.exports = __webpack_public_path__ + "img/maarten.c3641e8e.jpg";